module.exports = __webpack_public_path__ + "img/bingx.3fb61a2e.png";